import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import beianIcon from "../../common/img/备案图标.png";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";
import { Link } from "react-router-dom";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingBottom: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
            </FooterContainer>
          </Row>
        </Container>
        <Container>
          <Row justify="space-between">
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("联系地址")}</Title>
              <Para>江苏省 常州市 武进区</Para>
              <Para>牛塘青云工业区28号</Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Para>Copyright@2025</Para>
              <Para>常州佳顺智联有限责任公司 版权所有。</Para>
              <Para><a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2025215606号-1</a></Para>
              <Para><a href="https://beian.miit.gov.cn/" target="_blank">ICP许可：苏B2-20253935</a></Para>
              <Para><img src={beianIcon} style={{ height: '1em', verticalAlign: 'middle', marginRight: 4 }} /><a href="https://beian.mps.gov.cn/#/query/webSearch?code=32041202003868" rel="noreferrer" target="_blank">苏公网安备32041202003868号</a></Para>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
